module.exports = __webpack_public_path__ + "img/repair-3.d2d364ec.jpg";